import { Dialog, Flag, Typography } from '@packages/shared';
import { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { ServiceLayer } from '@packages/cms-components';
import { ecoFriendlyDeliveryMessages } from './messages';
import { useServiceLayerTracking } from '../Tracking/hooks/useServiceLayerTracking';

const serviceLayerId = 'eco_delivery_co2neutral';

/**
 * EcoFriendlyDelivery component
 * */
export const EcoFriendlyDelivery = () => {
  const { formatMessage } = useIntl();
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const { trackEcoFriendlyDeliveryClick, trackEcoFriendlyDeliverySeen } = useServiceLayerTracking();

  useEffect(() => {
    trackEcoFriendlyDeliverySeen(serviceLayerId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const clickHandler = () => {
    trackEcoFriendlyDeliveryClick(serviceLayerId);
    setIsModalOpen(true);
  };

  return (
    <>
      <Typography
        variant="body2"
        component="div"
        role="button"
        onClick={clickHandler}
        sx={{ cursor: 'pointer', my: 0.5 }}
      >
        {formatMessage(ecoFriendlyDeliveryMessages.co2FriendlyText, {
          flag: (
            <Flag
              sx={{ color: 'common.white', top: '-0.1em' }}
              type="sustainability"
              text={formatMessage(ecoFriendlyDeliveryMessages.co2FriendlyFlag)}
            />
          ),
        })}
      </Typography>
      <Dialog
        open={isModalOpen}
        handleClose={() => setIsModalOpen(false)}
        title={formatMessage(ecoFriendlyDeliveryMessages.dialogTitle)}
        dialogContent={<ServiceLayer serviceLayerId={serviceLayerId} />}
        displayTrackingProps={{ category: 'dv-service-layer-eco-friendly-delivery' }}
      />
    </>
  );
};
